import type { Lead } from '@/types';

import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';

interface AssignSelfConfirmModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  lead: Lead | null;
  isSubmitting: boolean;
  onConfirm: () => void;
}

export function AssignSelfConfirmModal({
  isOpen,
  onOpenChange,
  lead,
  isSubmitting,
  onConfirm,
}: AssignSelfConfirmModalProps) {
  if (!lead) return null;

  return (
    <Modal isOpen={isOpen} placement="center" onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Assign to Me</ModalHeader>
            <ModalBody>
              <p className="text-default-600">
                Are you sure you want to assign <span className="font-semibold">{lead.domain}</span> to yourself?
              </p>
            </ModalBody>
            <ModalFooter>
              <Button color="default" variant="light" onPress={onClose} isDisabled={isSubmitting}>
                Cancel
              </Button>
              <Button color="primary" onPress={onConfirm} isLoading={isSubmitting}>
                Yes, assign to me
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

